import React from "react";

function TaskFieldHidden(props) {
  return <input value={props.value} id={props.id} type="hidden" />;
}

// const mapStateToProps = createStructuredSelector({
//   value: (state, props) => selectFilterFormValuesSelector(state, props.id),
// });
// const mapDispatchToProps = {};
export default TaskFieldHidden;
